<template>
  <div>
    <header class="header">
      <div class="header-content">
        <img src="@/assets/images/logo.svg" class="logo" alt="">
        <h1 class="header-title">Chicchi Nails</h1>
      </div>
    </header>
    <div class="container">
        <div class="reviewed-card">
            <div class="reviewed-icon">
                <svg viewBox="0 0 52 52" width="70" height="70">
                    <circle cx="26" cy="26" r="25" fill="none" stroke="#FBC1C0" stroke-width="2"></circle>
                    <path d="M14.1 27.2l7.1 7.2 16.7-16.8" fill="none" stroke="#FBC1C0" stroke-width="3"></path>
                </svg>
            </div>
            <h3 class="reviewed-message">Appuntamento annullato</h3>
            <p class="reviewed-thanks">La tua prenotazione è stata annullata con successo. Grazie per la comprensione e il supporto.</p>
            <div class="back-button">
              <p class="back-link" @click="goBack">Torna alla Home</p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CancelReservation',
  data() {
    return {
      departmentId: null
    };
  },
  mounted() {
    this.departmentId = this.$route.query.id;
  },
  methods: {
    goBack() {
      this.$router.push('/home?id=' + this.departmentId);
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.main-content {
  text-align: center;
  margin-top: 40px;
}

.section-title {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
}

.button-container {
  margin-top: 20px;
}

.el-button {
  margin-right: 10px;
}
.header {
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  padding: 10px 0;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 10px;
}

.logo {
  height: 40px;
  margin-right: 15px;
}

.header-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}
/* 已评价状态卡片 */
.reviewed-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 30px 20px;
  margin-bottom: 20px;
  text-align: center;
}

.reviewed-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
}

.reviewed-message {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
}

.reviewed-thanks {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}
.back-button {
  margin-top: 30px;
  text-align: center;
}
.back-link {
  cursor: pointer;
}
</style>